import api from "@/lib/api";
import { toast } from "sonner";

const uid = () => {
  try { if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID(); } catch { /* noop */ }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0; const v = c === "x" ? r : (r & 0x3) | 0x8; return v.toString(16);
  });
};

// Adds an offer's items to the basket at the offer price.
// per_item + single product  -> adds that product at the discounted price
// per_item + multiple products -> opens the offer-filtered menu so the customer picks
// bundle -> adds all the offer's products as one set that costs the discounted price
export async function addOfferToCart(offer, { addItem, selectedBranch, navigate }) {
  const ids = offer.product_ids || [];
  const mode = offer.pricing_mode || "per_item";
  const disc = Number(offer.discounted_price) || 0;
  if (ids.length === 0) { navigate(`/menu?category=${encodeURIComponent(offer.type || "")}`); return; }
  if (mode !== "bundle" && ids.length > 1) { navigate(`/menu?offer_id=${encodeURIComponent(offer.id)}`); return; }

  const bid = selectedBranch?.id || "branch-1";
  let prods = [];
  try {
    const { data } = await api.get(`/menu/products?branch_id=${encodeURIComponent(bid)}&offer_id=${encodeURIComponent(offer.id)}`);
    prods = data || [];
  } catch { prods = []; }
  const byId = {}; prods.forEach((p) => { byId[p.id] = p; });
  const chosen = ids.map((id) => byId[id]).filter(Boolean);
  if (chosen.length === 0) { toast.error("This offer's items aren't available on the selected branch."); return; }

  if (mode === "bundle") {
    const grp = uid();
    chosen.forEach((p, i) => addItem({
      product_id: p.id, name: p.name, image: p.image,
      price: i === 0 ? disc : 0, quantity: 1, selected_options: [], special_instructions: "",
      offer_id: offer.id, offer_title: offer.title, meal_group: grp,
    }));
    toast.success(`${offer.title} added to basket`);
  } else {
    const p = chosen[0];
    addItem({
      product_id: p.id, name: p.name, image: p.image,
      price: disc, quantity: 1, selected_options: [], special_instructions: "",
      offer_id: offer.id, offer_title: offer.title,
    });
    toast.success(`${p.name} added at offer price`);
  }
}
